import * as React from "react";
const SvgClose1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M16.354 4.354a.5.5 0 0 0-.708-.708L10 9.293 4.354 3.646a.5.5 0 1 0-.708.708L9.293 10l-5.647 5.646a.5.5 0 0 0 .708.708L10 10.707l5.646 5.647a.5.5 0 0 0 .708-.708L10.707 10z", clipRule: "evenodd" }));
export {
  SvgClose1Px as S
};
//# sourceMappingURL=close-1px.BL6ZlEPp.mjs.map
